import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import { groupBy, keys } from 'lodash'
import { hasValue } from 'utils/NumberUtil'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import NewRadioButtons from 'components/forms/NewRadioButtons'

const ExportFileModal = ({
    open = false,
    data = [],
    title = '',
    maxWidth = 'lg',
    groups = [],
    onClose = () => { },
    closeOnExport = false,
}) => {
    const [dataChoice, setDataChoice] = useState(0)
    const [formatChoice, setFormatChoice] = useState(data?.[0]?.formats?.[0]?.type)

    const exportObj = data[dataChoice]

    const getCallback = () => {
        exportObj.formats.find(d => d.type === formatChoice)?.callback()
        if (closeOnExport) {
            onClose()
        }
    }

    const dataOptions = data.map((d, i) => ({
        ...d,
        value: i,
        label: d.name,
        group: d.group,
    }))
    const groupByDatas = groupBy(data, 'group')
    const listKeys = keys(groupByDatas).toSorted()

    return (
        <Dialog
            fullWidth
            maxWidth={maxWidth}
            open={open}
        >
            <DefaultDialogTitle
                title={title || i18n.chooseExportFormat}
                onClose={onClose}
            />
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={6}>
                        {listKeys.map(key => {
                            const groupFind = groups.find((g) => g.value === parseInt(key))
                            return (
                                <Grid key={key} size={12}>
                                    <StyledFieldSet style={{ padding: '10 20', margin: '0' }}>
                                        <StyledLegend>{(groupFind?.name || i18n.export)}</StyledLegend>
                                        <NewRadioButtons
                                            row={false}
                                            value={dataChoice}
                                            items={dataOptions.filter((d) => groupFind ? d.group === parseInt(key) : !hasValue(d.group))}
                                            onChange={(v) => {
                                                setDataChoice(v)
                                                setFormatChoice(dataOptions[v]?.formats?.[0]?.type)
                                            }}
                                            disabled={groupFind?.disabled}
                                        />

                                    </StyledFieldSet>
                                </Grid>
                            )
                        })}
                    </Grid>
                    <Grid container size={6}>
                        {exportObj?.settingsContent && (
                            <Grid size={12}>
                                <StyledFieldSet style={{ margin: '0' }}>
                                    <StyledLegend>{i18n.settings}</StyledLegend>
                                    {exportObj.settingsContent}
                                </StyledFieldSet>
                            </Grid>
                        )}
                        <Grid size={12}>
                            <StyledFieldSet style={{ padding: '10 20', margin: '0' }}>
                                <StyledLegend>{i18n.type}</StyledLegend>
                                <NewRadioButtons
                                    value={formatChoice}
                                    items={exportObj?.formats?.map((d) => ({ ...d, value: d.type, label: d.type }))}
                                    onChange={setFormatChoice}
                                />
                            </StyledFieldSet>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={getCallback}
                    variant='contained'
                    disabled={!(exportObj?.isReady?.() ?? true)}
                >
                    {i18n.export}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ExportFileModal.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    closeOnExport: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        group: PropTypes.number,
        settingsContent: PropTypes.element,
        formats: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.string,
            callback: PropTypes.func,
            disabled: PropTypes.bool,
        })),
    })).isRequired,
    grouped: PropTypes.bool,
    groups: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        name: PropTypes.string,
    })),
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
}

export default ExportFileModal